import type { DistanceUOM } from '../models/common.ts'
import { roundCurrency } from './number-helpers.ts'

export const KM_PER_MILE = 1.609344
export const distanceInMiles = (
  distance: number | null | undefined,
  distanceUOM: DistanceUOM | null | undefined,
) => {
  if (!distance || distance <= 0) return null
  if (distanceUOM === 'km') return distance / KM_PER_MILE
  return distance
}

export function calculateCostPerMile(
  amount: number,
  distanceMiles: number | null | undefined,
): number | null {
  if (amount <= 0 || !distanceMiles || distanceMiles <= 0) return null
  return roundCurrency(amount / distanceMiles)
}
